import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

declare var jQuery:any;
declare var $ :any;
declare var defaultGridViewSettings;
declare var globalConstants;
declare var getGlobalConstantDisplay;
declare var defaultSettingsGrid;

@Component({
  selector: 'system-int-h',
  templateUrl: './system-int-h.component.html',
  styleUrls: ['./system-int-h.component.css'],
})

export class SystemIntegrationHistory implements OnInit {

  constructor (private route: ActivatedRoute, private titleService: Title) { }

  ngOnInit() {

    //Set the page title
    this.titleService.setTitle("WiseRisk | System Integration Event Log");

  }
}



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/app/pages/history/system-int-h/system-int-h.component.ts